import template from './settings.html';
import controller from './settings.controller';

const settingsComponent = {
  template,
  controller,
  controllerAs: 'settings',
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&'
  }
};

export default settingsComponent;


/** WEBPACK FOOTER **
 ** ./frontend/components/admin/settings/settings.component.js
 **/